import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import AutoComplete from "../../../../../../components/form/AutoComplete";
import DatePicker from "../../../../../../components/form/DateTime";
import Input from "../../../../../../components/form/Input";
import CroField from "../../../generalForm/CroField";
import CroPriceField from "../../../generalForm/CroPriceField";
import {
  CroAddButton,
  CroRemoveButton,
} from "../../../generalForm/CroIconButtons";
import {
  fieldsRemove,
  notForPublic,
  isLogged,
  isNotLogged,
} from "../../../../CroUtils";
import * as V from "../../../../../../utils/formValidation";
import H from "../../../../helpEnum";
import Help from "../../../Help";
import { ItemNumber, useItemHandlers } from "./itemRenumber";

const Chattels = ({
  fields,
  disabled,
  noPublicLogged,
  dos,
  ongoing,
  wps,
  t,
  point3,
  ingoing,
  isPublicStatement,
  auth,
  outgoing,
  isCity,
  isVillage,
  selector,
  versionChangedClass,
}) => {
  const cityOrVillage = isNotLogged(auth) && !isCity && !isVillage;
  const { addItem, removeItem } = useItemHandlers(fields);
  return (
      <div className="cro-array-container">
        {fields.map((item, index) => {
          const chattelType = selector(`${item}.chattelType`);
          const behavior = chattelType && chattelType.behavior;
          const isCash = behavior === "CASH";
          const isBankAccount = behavior === "BANK_ACCOUNT";
          const isSpecial = isCash || isBankAccount;

          return (
              <div
                  key={index}
                  className={classNames("cro-array-item", {
                    noUnderline: !cityOrVillage,
                    [versionChangedClass ? versionChangedClass(item) : ""]: versionChangedClass,
                  })}
              >
                <ItemNumber index={index} />
                {!disabled && fields.length > 1 && (
                  <CroRemoveButton onClick={() => removeItem(index)} />
                )}
                <div className="cro-array-item-content">
                  <div className="statementForm__arrayGrid">
                    {(cityOrVillage || isLogged(auth)) && (
                        <CroField
                            className={versionChangedClass ? versionChangedClass(`${item}.chattelType`) : ""}
                            title="Druh movité věci"
                            name={`${item}.chattelType`}
                            component={AutoComplete}
                            disabled={disabled}
                            url="/api/ciselniky/druh-movite-veci"
                            validate={[V.required, V.isDictionary]}
                            helpEnum={H[`${t}CHATTEL_TYPE`].r}
                        />
                    )}

                    {isBankAccount && (
                        <CroField
                            className={versionChangedClass ? versionChangedClass(`${item}.bankInstitutionName`) : ""}
                            title="Název peněžní instituce"
                            name={`${item}.bankInstitutionName`}
                            component={Input}
                            disabled={disabled}
                        />
                    )}

                    {(!dos || (dos && (outgoing || ongoing))) &&
                        notForPublic(isPublicStatement, auth) && (
                            <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.ownership`) : ""}
                                title="Vlastnictví"
                                name={`${item}.ownership`}
                                component={AutoComplete}
                                disabled={disabled}
                                fullWidth
                                url="/api/ciselniky/zpusob-vlastnictvi"
                                validate={[V.isDictionary]}
                            />
                        )}

                    {isSpecial
                        ? (cityOrVillage || isLogged(auth)) && (
                        <CroPriceField
                            className={versionChangedClass ? versionChangedClass(`${item}.price`) : ""}
                            title="Výše v Kč"
                            name={`${item}.price`}
                            component={Input}
                            disabled={disabled}
                            validate={[V.required, V.isNumeric]}
                            helpEnum={H[`${t}CHATTEL_PRICE`].r}
                        />
                    )
                        : (
                            <>
                              {(cityOrVillage || (isLogged(auth) && !dos)) && (
                                  <CroPriceField
                                    className={versionChangedClass ? versionChangedClass(`${item}.price`) : ""}
                                    title={point3 || ingoing ? "Cena obvyklá" : "Pořizovací cena"}
                                    name={`${item}.price`}
                                    component={Input}
                                    disabled={disabled}
                                    validate={[V.required, V.isNumeric]}
                                    helpEnum={H[`${t}CHATTEL_PRICE`].r}
                                  />
                              )}
                              {dos && (
                                  <CroPriceField
                                    className={versionChangedClass ? versionChangedClass(`${item}.price`) : ""} 
                                    title="Pořizovací cena"
                                    name={`${item}.price`}
                                    component={Input}
                                    disabled={disabled}
                                    validate={[V.required, V.isNumeric]}
                                    helpEnum={H[`${t}CHATTEL_PRICE`].r}
                                  />
                              )}
                            </>
                        )}

                    {(cityOrVillage || isLogged(auth)) && (
                        <CroField
                            className={versionChangedClass ? versionChangedClass(`${item}.chattelAcquisition`) : ""}
                            title="Způsob nabytí"
                            name={`${item}.chattelAcquisition`}
                            component={AutoComplete}
                            disabled={disabled}
                            url="/api/ciselniky/nabyti-movite-veci"
                            validate={[V.required, V.isDictionary]}
                            helpEnum={H[`${t}CHATTEL_ACQUISITION`].r}
                        />
                    )}

                    {!point3 && wps > 1 && !dos && !isSpecial && (
                        <CroField
                            className={versionChangedClass ? versionChangedClass(`${item}.acquisitionDate`) : ""}
                            title="Datum nabytí"
                            name={`${item}.acquisitionDate`}
                            component={DatePicker}
                            disabled={disabled}
                            validate={[V.required]}
                        />
                    )}
                    {noPublicLogged && (
                        <div className="statementForm__arrayFull">
                          <CroField
                            className={versionChangedClass ? versionChangedClass(`${item}.note`) : ""}
                            title="Poznámka"
                            name={`${item}.note`}
                            component={Input}
                            disabled={disabled}
                            multiLine
                            helpEnum={H[`${t}CHATTEL_NOTE`].r}
                            maxlen={1000}
                          />
                        </div>
                    )}
                  </div>
                </div>
              </div>
          );
        })}
        {!disabled && (
            <div className="cro-array-add">
              <CroAddButton onClick={() => addItem()} />
              <Help helpEnum={H.ADD_REMOVE_CHATTELS.r} />
            </div>
        )}
      </div>
  );
};

export default connect((state) => ({
  selector: (select) => formValueSelector("statementForm")(state, select),
}))(Chattels);
